import React, { useEffect, useRef } from 'react';
import {
    enable as enableDarkMode,
    disable as disableDarkMode,
} from 'darkreader';
import { useSpreadSheet } from '../../context/spreadsheet-context';
import DarkModeToggle, { useDarkMode } from '../DarkModeToggle';

const DARK_MODE_THEME = { brightness: 100, contrast: 90, sepia: 10 };

// Without this darkreader injects a proxy <script> that references tslib's
// __assign, which the page does not have, and throws on every enable.
const DARK_MODE_FIXES = { disableStyleSheetsProxy: true };

function Modes({ scale }) {
    const { dark } = useDarkMode();
    const { spreadsheetInstanceRef } = useSpreadSheet();
    const applied = useRef(null);

    useEffect(() => {
        if (applied.current === dark) return;
        applied.current = dark;

        if (dark) {
            enableDarkMode(DARK_MODE_THEME, DARK_MODE_FIXES);
        } else {
            disableDarkMode();
        }

        Array.from(document.getElementsByClassName('x-spreadsheet-icon')).forEach((tool) => {
            tool.style.filter = dark ? 'invert(.9)' : 'none';
        });

        const sheet = spreadsheetInstanceRef?.current?.sheet ?? null;
        if (sheet?.data) {
            sheet.data.isDarkMode = dark;
            sheet.table.render();
        }
    }, [dark, spreadsheetInstanceRef]);

    return <DarkModeToggle scale={scale} />;
}

export default Modes;
